const toUiSettingProjection = (uiSettingDto) => ({
    id: uiSettingDto.id,
    key: uiSettingDto.key,
    value: uiSettingDto.value,
});
const storageUiSettingByKeyView = ({ storage }) => async ({ key }) => {
    try {
        const uiSettingDto = await storage.read(key);
        return uiSettingDto ? toUiSettingProjection(uiSettingDto) : null;
    }
    catch (_ignored) {
        throw new Error("Could not fetch the uiSetting");
    }
};
export { storageUiSettingByKeyView };
